// DEPRECATED - Eligibility PDF was based on leads table which is no longer used.
// Kept for API compatibility. Returns safe defaults.
import { useState } from 'react';

// DEPRECATED - Returns safe defaults. Eligibility PDF was linked via leads table.
export function useEligibilityPdf(_leadId: string) {
  const [hasPdf] = useState(false);
  const [pdfLinked] = useState(false);
  const [isLinking] = useState(false);
  const [loading] = useState(false);

  async function linkPdf() {
    // DEPRECATED - no-op
    console.warn('[DEPRECATED] useEligibilityPdf.linkPdf called - leads table deprecated');
  }

  async function checkPdfStatus() {
    // DEPRECATED - no-op
  }

  return {
    hasPdf,
    pdfLinked,
    loading,
    isLinking,
    linkPdf,
    refresh: checkPdfStatus,
  };
}
